// Individual modules
var bravo = bravo || {};
bravo.utilities = (function () {
	'use strict';

	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	const debounce = (func, wait, immediate) => {
		let timeout;

		return function () {
			const context = this,
				args = arguments;
			const later = function () {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			const callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	};

	var throttle = function (callback, delay) {
		var throttleTimeout = null;
		var storedEvent = null;

		var throttledEventHandler = function (event) {
			storedEvent = event;

			var shouldHandleEvent = !throttleTimeout;

			if (shouldHandleEvent) {
				callback(storedEvent);

				storedEvent = null;

				throttleTimeout = setTimeout(function () {
					throttleTimeout = null;

					if (storedEvent) {
						throttledEventHandler(storedEvent);
					}
				}, delay);
			}
		};

		return throttledEventHandler;
	};

	var getCurrentViewport = function () {
		return window
			.getComputedStyle(document.querySelector('body'), ':before')
			.getPropertyValue('content')
			.replace(/["']/g, '');
	};

	// var setCookie = function(name, value, days) {
	// 	var expires = '';
	// 	if (days) {
	// 		var date = new Date();
	// 		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	// 		expires = '; expires=' + date.toUTCString();
	// 	}
	// 	document.cookie = name + '=' + (value || '') + expires + '; path=/';
	// };

	// var getCookie = function(name) {
	// 	var nameEq = name + '=';
	// 	var ca = document.cookie.split(';');
	// 	for (var i = 0; i < ca.length; i++) {
	// 		var c = ca[i];
	// 		while (c.charAt(0) === ' ') {
	// 			c = c.substring(1, c.length);
	// 		}
	// 		if (c.indexOf(nameEq) === 0) {
	// 			return c.substring(nameEq.length, c.length);
	// 		}
	// 	}

	// 	return null;
	// };

	// var eraseCookie = function(name) {
	// 	document.cookie = name + '=; Max-Age=-99999999;';
	// };

	return {
		debounce: debounce,
		throttle: throttle,
		getCurrentViewport: getCurrentViewport
		// getCookie: getCookie,
		// setCookie: setCookie,
		// eraseCookie: eraseCookie
	};
})();
bravo.nav = (function () {
	'use strict';

	const initialise = () => {
		const header = document.querySelector('.header'),
			heroSection = document.querySelector('.section-hero');

		let heroSectionHeight,
			headerHeight,
			isScrolling = false,
			isResizing = false;

		// annoying var that's needed because the navigation will always turn dark if the mobile menu is opened, even if the navbar is light
		// we need Bootstrap to swap the 'navbar-light' and 'navbar-dark' classes, but also for it to remember if the navbar is meant to be light when the nav is closed
		let headerHasLightClass = false;

		const getHeroAndNavHeight = () => {
			heroSectionHeight = heroSection.offsetTop + heroSection.clientHeight;
			headerHeight = header.offsetHeight;
		};
		getHeroAndNavHeight();

		// Get heights of hero and header after resize. If we do it on scroll then it can return the wrong values if the mobile nav is opened
		window.addEventListener('resize', () => {
			if (!isResizing) {
				window.requestAnimationFrame(() => {
					isResizing = false;
					getHeroAndNavHeight();
				});

				isResizing = true;
			}
		});

		// if scrolled below the hero section, turn the navbar light
		if (heroSection) {
			const switchClassAfterHero = () => {
				let diffOffset = heroSectionHeight - headerHeight - 100 - window.pageYOffset;

				if (diffOffset <= 0) {
					header.classList.add('header-light');
					headerHasLightClass = true;
				} else {
					header.classList.remove('header-light');
					headerHasLightClass = false;
				}
			};

			document.addEventListener('scroll', () => {
				if (!isScrolling && !header.classList.contains('mobile-nav-shown')) {
					window.requestAnimationFrame(() => {
						isScrolling = false;
						switchClassAfterHero();
					});

					isScrolling = true;
				}
			});

			switchClassAfterHero();
		}

		$('#primary-nav').on('show.bs.collapse', function () {
			header.classList.add('mobile-nav-shown');

			if (headerHasLightClass) {
				header.classList.remove('header-light');
			}
		});

		$('#primary-nav').on('hide.bs.collapse', function () {
			header.classList.remove('mobile-nav-shown');

			if (headerHasLightClass) {
				header.classList.add('header-light');
			}
		});
	};

	return {
		init: initialise
	};
})();
bravo.forms = (function () {
	'use strict';

	const unlistedInvestmentForm = (el) => {
		// to replace the confirmation checkbox text with a field fed from the CMS
		const investmentDisclaimer = el.querySelector('#commissionDisclaimer');
		const confirmationCheckbox = el.querySelector('.umbraco-forms-field.confirm.checkbox .label');
		if (investmentDisclaimer && confirmationCheckbox) {
			confirmationCheckbox.textContent = investmentDisclaimer.value;
		}
	};

	return {
		unlistedInvestmentForm
	};
})();
(function () {
	'use strict';

	const $navbarToggler = $('#navbar-toggler');

	$('a[href*="#"]').click(function () {
		const $el = $(this);

		// if a main nav anchor link is clicked on mobile, close the nav
		if ($el.closest('.navbar').length && !$el.hasClass('dropdown-toggle')) {
			if ($navbarToggler.attr('aria-expanded') === 'true') {
				$navbarToggler.click();
			}
		}
	});
})();
/* globals Swiper */
bravo.swiper = (function () {
	'use strict';

	const initialise = () => {
		for (const swiperEl of document.querySelectorAll('.swiper-container')) {
			const swiperSlides = swiperEl.querySelectorAll('.swiper-slide');
			const swiperNavigation = swiperEl.querySelector('.swiper-navigation');

			if (!swiperSlides.length || !swiperNavigation) continue;

			const swiperPagination = swiperNavigation.querySelector('.swiper-pagination');
			const swiperNext = swiperNavigation.querySelector('.swiper-button-next');
			const swiperPrev = swiperNavigation.querySelector('.swiper-button-prev');

			if (swiperSlides.length === 1) {
				swiperEl.classList.add('disabled');
				swiperNavigation.style.setProperty('display', 'none', 'important'); // fighting Boostrap !important classes
				continue;
			}

			new Swiper(swiperEl, {
				loop: true,
				pagination: {
					el: swiperPagination,
					clickable: true
				},
				slidesPerView: 'auto',
				watchOverflow: true,

				navigation: {
					nextEl: swiperNext,
					prevEl: swiperPrev
				}
			});
		}
	};

	return {
		init: initialise
	};
})();
bravo.videoEmbed = (function () {
	'use strict';

	const init = () => {
		if (document.querySelector('[data-selector="embed-vimeo"]')) {
			for (const vimeoPlayer of document.querySelectorAll('[data-selector="embed-vimeo"]')) {
				const player = new Vimeo.Player(vimeoPlayer.id);
				const thumbnail = vimeoPlayer.nextElementSibling;

				if (thumbnail) {
					thumbnail.addEventListener('click', () => {
						thumbnail.style.opacity = 0;
						thumbnail.style.pointerEvents = 'none';
						player.play();
					});
				}
			}
		}
	};

	return {
		init
	};
})();
/* globals SignaturePad */

bravo.signature = (function () {
	'use strict';

	const initialisePad = (fieldId) => {
		if (!fieldId) {
			return;
		}

		let previousDisplayState;

		const wrapper = document.getElementById('signature-pad-' + fieldId);
		const parentWrapper = wrapper.closest('.umbraco-forms-field');
		const canvasType = wrapper.querySelector('#type-pad-' + fieldId);
		const inputType = wrapper.querySelector('#type-input-' + fieldId);
		const canvasDraw = wrapper.querySelector('#draw-pad-' + fieldId);
		const field = document.getElementById(fieldId);
		const clearButton = wrapper.querySelector('[data-action="clear"]');
		// jQuery selectors since that's what Bootstrap asks for
		const $tabType = $(parentWrapper).find('[data-selector="tab-type"]');
		const $tabDraw = $(parentWrapper).find('[data-selector="tab-draw"]');

		// since we need to transform-to-text the <canvas> contents of both signature pads (the one that's draw-able and the one that's rendered from text), it's necessary that they're both init'd as a signaturePad
		const signaturePads = {
			textPad: new SignaturePad(canvasType, {
				backgroundColor: 'rgb(238, 238, 238)'
			}),
			drawPad: new SignaturePad(canvasDraw, {
				// It's Necessary to use an opaque color when saving image as JPEG;
				// this option can be omitted if only saving as PNG or SVG
				backgroundColor: 'rgb(255, 255, 255)',
				onEnd: function () {
					const drawPadDataURL = this.toDataURL();
					field.value = drawPadDataURL;
				}
			})
		};

		// we only want mouse listeners on the drawPad
		signaturePads.textPad.off();

		function clearCanvases() {
			for (const signaturePad of Object.values(signaturePads)) {
				// When zoomed out to less than 100%, for some very strange reason,
				// some browsers report devicePixelRatio as less than 1
				// and only part of the canvas is cleared then.
				const ratio = Math.max(window.devicePixelRatio || 1, 1);

				// This part causes the canvas to be cleared
				signaturePad._canvas.width = signaturePad._canvas.offsetWidth * ratio;
				signaturePad._canvas.height = signaturePad._canvas.offsetHeight * ratio;
				signaturePad._ctx.scale(ratio, ratio);

				// This library does not listen for canvas changes, so after the canvas is automatically
				// cleared by the browser, SignaturePad#isEmpty might still return false, even though the
				// canvas looks empty, because the internal data of this library wasn't cleared. To make sure
				// that the state of this library is consistent with visual state of the canvas, you
				// have to clear it manually.
				signaturePad.clear();
			}
		}

		function textToCanvas(value) {
			clearCanvases();
			const ctx = canvasType.getContext('2d');
			ctx.font = '24px "Homemade Apple", sans-serif';
			ctx.fillText(value, 10, 50);
			field.value = signaturePads.textPad.toDataURL(field.value);
		}

		function resizeCanvases() {
			// check if the Type field is filled
			if (inputType.value) {
				textToCanvas(inputType.value);
			}
		}

		// Show function and Hide function for multiple Signature sections, which can be conditionally shown/hidden in the Umbraco form
		function show() {
			if (previousDisplayState !== 'show') {
				previousDisplayState = 'show';
				resizeCanvases();
			}
		}

		function hide() {
			if (previousDisplayState !== 'hide') {
				previousDisplayState = 'hide';
				inputType.value = '';
				field.value = '';
				clearCanvases();
			}
		}

		$tabType.on('hidden.bs.tab', function () {
			inputType.value = '';
			field.value = '';
			clearCanvases();
		});

		$tabDraw.on('hidden.bs.tab', function () {
			field.value = '';
			clearCanvases();
		});

		window.addEventListener('resize', bravo.utilities.debounce(resizeCanvases, 500));
		clearButton.addEventListener('click', function () {
			field.value = '';
			clearCanvases();
		});

		parentWrapper.addEventListener('show', show);
		parentWrapper.addEventListener('hide', hide);

		inputType.addEventListener(
			'keydown',
			bravo.utilities.debounce(function (e) {
				textToCanvas(e.target.value);
			}, 500)
		);
	};

	const initialise = () => {
		for (const pad of document.querySelectorAll('.signature-pad')) {
			initialisePad(pad.dataset.fieldId);
		}
	};

	return {
		init: initialise
	};
})();